module.exports = __webpack_public_path__ + "img/public/SiteIcons/securityIcon2.svg?01aae412";